import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "cm-align-center" }
const _hoisted_2 = {
  class: "cm-align-center",
  style: {"gap":"3px"}
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { style: {"padding-left":"4px"} }

import { computed, PropType } from 'vue';
import { useI18n } from 'vue-i18n';

export default /*#__PURE__*/_defineComponent({
  __name: 'Keywords',
  props: {
  maxChars: {
    type:Number,
    default: 30
  },
  toolContentWidth:{
    type:Number,
    default: 300
  },
  maxCount: {
    type: Number,
    default: 3,
  },
  placement: {
    type: String,
    default: "top",
  },
  stringType:{
    type:Boolean,
    default: false
  },
  keywords: {
    type: Array as PropType<string[]>,
    default: () => [],
    required: true,
  }
},
  setup(__props) {

const {t} = useI18n()
const props = __props;
const parseKeywords = computed(() => Array.isArray(props.keywords)? props.keywords.filter(item => item.trim()):[])

return (_ctx: any,_cache: any) => {
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (__props.stringType)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(parseKeywords.value?.slice?.(0, __props.maxCount)+''), 1))
        : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(parseKeywords.value?.slice?.(0, __props.maxCount), (tag) => {
            return (_openBlock(), _createBlock(_component_el_tag, {
              type: "primary",
              title: tag,
              size: "small",
              round: ""
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(tag.slice(0, __props.maxChars) + (tag.length > __props.maxChars ? '...' : '')), 1)
              ]),
              _: 2
            }, 1032, ["title"]))
          }), 256))
    ]),
    (parseKeywords.value.length > __props.maxCount)
      ? (_openBlock(), _createBlock(_component_el_tooltip, {
          key: 0,
          placement: __props.placement
        }, {
          content: _withCtx(() => [
            _createElementVNode("div", {
              style: _normalizeStyle({maxWidth: __props.toolContentWidth+'px'})
            }, _toDisplayString(parseKeywords.value+''), 5)
          ]),
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('common.total_keyword',{count:parseKeywords.value.length})), 1)
          ]),
          _: 1
        }, 8, ["placement"]))
      : _createCommentVNode("", true)
  ]))
}
}

})